import {
  ChangeDetectionStrategy,
  Component, input, ViewEncapsulation,
} from '@angular/core';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { INavGroupBlock } from './nav-group.model';

@Component({
    selector: 'app-nav-group',
    imports: [CmsComponent],
    templateUrl: './nav-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class NavGroupComponent {
    block = input.required<INavGroupBlock>();
    title = input<string>();
}
